export default __webpack_public_path__ + "static/media/frontpage2.527a52c3.txt";